import { render, staticRenderFns } from "./DetailVideo.vue?vue&type=template&id=44324268&scoped=true"
import script from "./DetailVideo.vue?vue&type=script&lang=js"
export * from "./DetailVideo.vue?vue&type=script&lang=js"
import style0 from "./DetailVideo.vue?vue&type=style&index=0&id=44324268&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44324268",
  null
  
)

export default component.exports